export const getStatistics = answer => {
  const hasMdsVersion2Plus = answer?.mds?.version >= 2

  const hasScoreRange = answer?.meanStat !== undefined

  return {
    showRsq: hasMdsVersion2Plus && answer.mds.rsq !== undefined,
    rsqPercentage: hasMdsVersion2Plus && answer.mds.rsq !== undefined ? (answer.mds.rsq * 100).toFixed(1) : null,
    scoreRange: hasScoreRange ? `${answer.meanStat.min.toFixed(1)}-${answer.meanStat.max.toFixed(1)}` : ''
  }
}

export const calcColors = ({ percents = [], colors = [] }) =>
  percents.map((percent, index) => {
    return {
      color: colors[index],
      text: `${percent}%tile`
    }
  })
